import React from 'react';
import TextInput from '../../../components/UIComponent/TextInput';
import ModalBasic from '../../component/ModalBasic';
import ToggleSwitch from '../../../components/common/ToggleSwitch';
import MultiSelectDropdown from '../../../components/dropdown/MultiSelectDropdown';

function UserPermissionPopup(props) {

    return (
        <ModalBasic
            id="user-permission"
            classParams="!w-[55%]"
            modalOpen={props.isModalOpen}
            setModalOpen={props.setOpenModel}
        >
            <div className='input-fields p-[30px]'>
                <span className="text-blue text-[16px] font-semibold">User details</span>

                <div className='item-grp grid grid-cols-2 gap-2.5 items-start mt-3 mb-3'>

                    <div className='input-grp'>
                        <label>Person Name</label>
                        <TextInput 
                            type='text'
                            id='personName'
                            name='personName'
                            value={props.permissionObject.personName}
                            handleChange={(event) => props.handleChange(event, 'personName')}
                            className={props.validState?.error?.personName ? "error" : ""}
                        />
                    </div>

                    <div className='input-grp'>
                        <label>Username</label>
                        <TextInput 
                            type='text'
                            id='username'
                            name='username'
                            value={props.permissionObject.username}
                            handleChange={(event) => props.handleChange(event, 'username')}
                            className={props.validState?.error?.username ? "error" : ""}
                        />
                    </div>

                    <div className='input-grp'>
                        <label>Password</label>
                        <TextInput
                            type="password"
                            id="password"
                            name="password"
                            value={props.permissionObject.password}
                            handleChange={(event) => props.handleChange(event, 'password')}
                            className={props.validState?.error?.password ? "error" : ""}
                            isPassword={true}
                            showPassword={props.showPassword}
                            togglePassword={props.togglePassword}
                        />
                    </div>

                    <div className='input-grp'>
                        <label>Plant</label>
                        <MultiSelectDropdown
                            className={props.validState?.error?.idPlant !== undefined ? "error" : ""}
                            options={props.plants}
                            value={props.permissionObject.idPlant ? props.plants?.find(x => x.value === props.permissionObject.idPlant) : null}
                            onChange={(event) => props.handleChangeFroDropdown(event, "idPlant")}
                        />
                    </div>

                    <div className='input-grp'>
                        <label>Role</label>
                        <MultiSelectDropdown
                            className={props.validState?.error?.roleId !== undefined ? "error" : ""}
                            options={props.roles}
                            value={props.permissionObject.roleId ? props.roles?.find(x => x.value === props.permissionObject.roleId) : null}
                            onChange={(event) => props.handleChangeFroDropdown(event, "roleId")}
                        />
                    </div>

                    {/* <div className='input-grp !flex gap-[10px] items-center mt-5 '>
                        <label>Is Active</label>
                        <ToggleSwitch
                            checked={props.permissionObject.isActive}
                            onChange={(e) => props.handleToggle(e, "isActive")}
                        />
                    </div> */}

                </div>

                {props.selectedId > 0 ?
                    <div className='btn-grp flex gap-2.5 mt-5'>
                        <button className="update-btn btns" onClick={() => props.submit()}>Update</button>
                        <button className="delete-btn btns" onClick={() => props.delete()}>Delete</button>
                    </div>
                    :
                    <div className='btn-grp flex gap-2.5 mt-5'>
                        <button className="update-btn btns" onClick={() => props.submit()}>Save</button>
                        <button className="delete-btn btns" onClick={() => props.close()}>Cancel</button>
                    </div>
                }

            </div>

        </ModalBasic>
    )
}

export default UserPermissionPopup;